import {sqftPost} from "./sqftApi";

export default class SqftJsonApi {
  static postCabinetSet(data) {
    return sqftPost( "/api/AR/Composer", data);
  }
}
